export default __webpack_public_path__ + "static/1inch-aae74c47e26dbdbc5c0c29f64c82a50b.svg";